import { h, render } from "preact";
import "preact/devtools"; // just want the devtools bridge (~240B)

import "./css/live-asr.scss";
import { App } from "./App";
import { getClientAttributes } from "./_implementation/getClientAttributes";

function initializeApp() {
  const appRoot = document.getElementById("live-asr-client") as Element;

  render(<App {...getClientAttributes()} />, appRoot);
}

initializeApp();
